import { render } from "./statistique.vue?vue&type=template&id=792ff808&scoped=true"
import script from "./statistique.vue?vue&type=script&lang=js"
export * from "./statistique.vue?vue&type=script&lang=js"

import "./statistique.vue?vue&type=style&index=0&id=792ff808&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Latitude E5570\\Desktop\\MES DOSSIERS\\REAL_ESTATE_DEXTER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-792ff808"]])

export default __exports__